import React, { ChangeEvent } from 'react'
import { Switch } from '@at/design-system-elements'
import { useFilter } from '../../forms/hocs/filter.context.hoc'
import { FilterComponentProp } from '../../forms/hocs/types'
import { StyledLabelAndIconContainer } from '../search-filters-checkbox/search-filters-checkbox.styles'
import { FilterTitle } from '../expandable-filter/expandable-filter.styles'
import { StyledSwitchContainer } from './search-filters-switch.styles'

export const SearchFiltersSwitch = ({ option, icon }: FilterComponentProp) => {
    const { onValueChanged, selected, title, isDisabled, filterName } = useFilter()
    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            onValueChanged(['true'])
        } else {
            onValueChanged([])
        }
    }
    const isChecked = selected.length > 0
    return (
        <StyledSwitchContainer as="label" htmlFor={`${filterName}-switch`} tabIndex={0}>
            <StyledLabelAndIconContainer>
                {icon && icon}
                <FilterTitle as="span">{`${option?.label || title}`}</FilterTitle>
            </StyledLabelAndIconContainer>
            <Switch
                id={`${filterName}-switch`}
                name={`${filterName}-switch`}
                label={''}
                onChange={onChange}
                disabled={isDisabled}
                checked={isChecked}
            />
        </StyledSwitchContainer>
    )
}
